
import moment, { Moment } from "moment"
import { getItemWidth } from "../Components/GantV2/GanttHelper"
import { aIsAfterB, aIsBeforeB, aIsSameOrAfterB, aIsSameOrBeforeB, getYMDFromDate } from "./DateFunctions"

type ProgrammationSchema = 'macro' | 'lookahead' | 'weekly'

export const filterByUsers = (items: any[], users: string[]) => {

  const filteredItems: any[] = []

  items.forEach((item: any) => {

    if (item.type === 'task') {

      const foundInUsers = item.task.responsibles.find((responsible: any) => users.includes(responsible._id))
      const foundInProfiles = item.task.internalProfiles.find((profile: any) => users.includes(profile._id))

      if (foundInUsers || foundInProfiles) {

        filteredItems.push(item)
      }
    } else {

      item.group.items = filterByUsers(item.group.items, users)

      if (item.group.items.length) {

        filteredItems.push(item)
      }
    }
  })

  return filteredItems
}

export const filterByGroups = (items: any[], groups: string[]) => {

  const filteredItems: any[] = []

  items.map((item: any) => {

      if (item.type === 'group') {

          if (groups.includes(item.group._id)) {

              filteredItems.push(item)
          } else {

              item.group.items = filterByGroups(item.group.items, groups)

              if (item.group.items.length) {

                  filteredItems.push(item)
              }
          }
      }
  })

  return filteredItems
}

export const filterByColorCodes = (items: any[], colorCodes: string[]) => {

  const filteredItems: any[] = []

  items.forEach((item: any) => {

      if (item.type === 'task') {

          const colorCode = item.task.colorCode
          const hasColorCode = colorCode && colorCodes.includes(colorCode._id.toString())

          const subTasksWithColorCode: any[] = []
          if (item.task.hasSubTasks) {

            item.task.subTasks.forEach((subTask: any) => {

              if (subTask.colorCode && colorCodes.includes(subTask.colorCode._id.toString())) {

                console.log('colorCode', subTask.colorCode)

                subTasksWithColorCode.push(subTask)
              }
            })

            console.log('subTasksWithColorCode', subTasksWithColorCode)
          }

          if (hasColorCode || subTasksWithColorCode.length) {

            const newTask = {
              ...item.task,
              subTasks: subTasksWithColorCode,
            }

            console.log('newTask', newTask)

            const newItem: any = {
              ...item,
              subTasks: subTasksWithColorCode,
              task: newTask,
            }

            // newItem.task.subTasks = subTasksWithColorCode

            console.log('newItem', newItem)

            filteredItems.push(newItem)
          }


      } else {

          item.group.items = filterByColorCodes(item.group.items, colorCodes)

          if (item.group.items.length) {

              filteredItems.push(item)
          }
      }
  })

  return filteredItems
}

export const filterByTypes = (items: any[], types: string[]) => {

  const filteredItems: any[] = []

  items.map((item: any) => {

      if (item.type === 'task') {

        const mustShowItsSubtasks = item.subTasks?.length && types.includes('trabajo')

          if (types.includes(item.task.type) || mustShowItsSubtasks) {

              filteredItems.push(item)
          }
      } else {

          item.group.items = filterByTypes(item.group.items, types)

          if (item.group.items.length) {

              filteredItems.push(item)
          }
      }
  })

  return filteredItems
}

export const filterByStatus = (items: any[], status_arr: string[]) => {

  const filteredItems: any[] = []

  items.forEach((item: any) => {

      if (item.type === 'task') {

          if (status_arr.includes(item.task.status === 'activa-atrasada' ? 'activa_atrasada' : item.task.status)) {

              filteredItems.push(item)
          }
      } else {

          item.group.items = filterByStatus(item.group.items, status_arr)

          if (item.group.items.length) {

              filteredItems.push(item)
          }
      }
  })

  return filteredItems
}

const matchDatesConditions = (task: any, start: string, end: string) => {

  const startsAt = new Date(task.startsAt)
  const endsAt = new Date(task.endsAt)

  const task_start = getYMDFromDate(startsAt)
  const task_end = getYMDFromDate(endsAt)

  if (start && !end) {

    if (aIsSameOrAfterB(task_end, start))
      return true

  } else if (!start && end) {

    if (aIsSameOrBeforeB(task_start, end))
      return true

  } else if (start && end) {

    const ends_same_or_before_start = aIsSameOrAfterB(task_end, start)
    const starts_same_or_after_end = aIsSameOrBeforeB(task_start, end)

    if (ends_same_or_before_start && starts_same_or_after_end)
      return true
  }

  return false
}

export const filterByDate = (items: any, start: string, end: string) => {

  const filteredItems: any[] = []

  items.map((item: any) => {

      if (item.type === 'task') {

          if (matchDatesConditions(item.task, start, end)) {

              filteredItems.push(item)
          }
      } else {

          item.group.items = filterByDate(item.group.items, start, end)

          if (item.group.items.length) {

              filteredItems.push(item)
          }
      }
  })

  return filteredItems
}

export const getMacroResult = ({ list, tasks, users, colorCodes, relations, filters, parentGroupId }: any) => {

  list.forEach((item: any, i: number) => {

    const position = `${parentGroupId ? parentGroupId + '.' : ''}${i + 1}`

    if (item.type === 'task') {

      const task = tasks.find((t: any) => t._id === item.task)

      if (!task)
        return

      task.position = position

      task.startsAt = moment.utc(task.startsAt).format('YYYY-MM-DD HH:mm')
      task.endsAt = moment.utc(task.endsAt).format('YYYY-MM-DD HH:mm')

      if (task.colorCode && typeof task.colorCode === 'string')
        task.colorCode = colorCodes.find((cc: any) => `${cc._id}` === `${task.colorCode}`)

      task.comments = task.comments.map((comment: any) => {

        comment.user = users.find((u: any) => u._id === comment.user)

        return comment
      })

      task.restrictions = task.restrictions.map((rest: any) => {

        return {
          ...rest,
          createdBy: users.find((user: any) => user._id === rest.createdBy)
        }
      })

      task.relations = relations.filter((relation: any) => {

        return relation.from_task === task._id || relation.to_task === task._id
      })

      item.task = task

      if (item.subTasks && item.subTasks.length) {

        const subTasks: any[] = []

        item.subTasks.map((subTaskId: any) => {

          const subTask = typeof subTaskId !== 'string' ? subTaskId : tasks.find((task: any) => task._id === subTaskId)

          if (!subTask ) return

          if (subTask.colorCode && typeof subTask.colorCode === 'string')
            subTask.colorCode = colorCodes.find((cc: any) => `${cc._id}` === `${subTask.colorCode}`)

          subTask.restrictions = subTask.restrictions.map((rest: any) => {

            return {
              ...rest,
              createdBy: users.find((user: any) => user._id === rest.createdBy)
           }
          })

          subTasks.push(subTask)
        })

        item.subTasks = subTasks
        item.task.subTasks = subTasks
      }
    } else {

      item.group.position = position

      item.group.items = getMacroResult({
        list: item.group.items,
        tasks,
        users,
        colorCodes,
        relations,
        filters,
        parentGroupId: position
      })
    }
  })

  return list
}

export const getLookaheadResult = (options: any) => {

  const newList: any[] = []

  options.list.forEach((item: any, i: number) => {

    const position = `${options.parentGroupId ? options.parentGroupId + '.' : ''}${i + 1}`

    if (item.type === 'task') {

      const task = options.tasks.find((task: any) => task._id === item.task)

      if (!task)
        return

      const start = task.startedAt || task.startsAt
      let end

      if (!task.startedAt) {

        end = task.endsAt
      } else if (task.endedAt) {

        end = task.endedAt
      } else if (task.startedAt && !task.endedAt) {

        end = getExpectedEndDate(task.startedAt, task.executeDays, options.nonWorkingDays, true)
      }

      const startsBeforeLookeaheadStart = aIsBeforeB(start, options.navigator.startDay)
      const startsSameOrAfterLookaheadStart = aIsSameOrAfterB(start, options.navigator.startDay)
      const startsSameOrBeforeLookaheadEnd = aIsSameOrBeforeB(start, options.navigator.endDay)

      const endsSameOrAfterLookaheadStart = aIsSameOrAfterB(end, options.navigator.startDay)
      const endsAfterLookaheadEnd = aIsAfterB(end, options.navigator.endDay)
      const endsSameOrBeforeLookaheadEnd = aIsSameOrBeforeB(end, options.navigator.endDay)

      const startsBeforeButEndsInRange = startsBeforeLookeaheadStart && endsSameOrAfterLookaheadStart && endsSameOrBeforeLookaheadEnd
      const startsBeforeButEndsAfterRange = startsBeforeLookeaheadStart && endsAfterLookaheadEnd
      const startsInRangeAndEndsInRange = startsSameOrAfterLookaheadStart && endsSameOrBeforeLookaheadEnd
      const startsInRangeButEndsAfter = startsSameOrAfterLookaheadStart && startsSameOrBeforeLookaheadEnd && endsAfterLookaheadEnd

      if (startsBeforeButEndsInRange || startsBeforeButEndsAfterRange || startsInRangeAndEndsInRange || startsInRangeButEndsAfter) {

        task.position = position

        task.startsAt = moment.utc(task.startsAt).format('YYYY-MM-DD HH:mm')
        task.endsAt = moment.utc(task.endsAt).format('YYYY-MM-DD HH:mm')

        if (task.colorCode)
          task.colorCode = options.colorCodes.find((cc: any) => cc._id === task.colorCode)

        task.comments = task.comments.map((comment: any) => {

          comment.user = options.users.find((u: any) => u._id === comment.user)

          return comment
        })

        task.responsibles = task.responsibles.map((resp: string) => {

          if (typeof resp !== 'string') return resp

          return options.users.find((user: any) => user._id === resp)
        })

        task.restrictions = task.restrictions.map((rest: any) => {

          return {
            ...rest,
            createdBy: options.users.find((user: any) => user._id === rest.createdBy)
          }
        })

        task.relations = options.relations.filter((relation: any) => {

          return relation.from_task === task._id || relation.to_task === task._id
        })

        item.task = task

        if (item.subTasks && item.subTasks.length) {

          item.subTasks = item.subTasks.map((subTaskId: string) => {

            const subTask = options.tasks.find((task: any) => task._id === subTaskId)

            if (subTask.colorCode)
              subTask.colorCode = options.colorCodes.find((cc: any) => cc._id === subTask.colorCode)

            return subTask
          }).filter((subTask: any) => {

            const start = subTask.startedAt || subTask.startsAt
            let end

            if (!subTask.startedAt) {

              end = subTask.endsAt
            } else if (subTask.endedAt) {
              end = subTask.endedAt
            } else if (subTask.startedAt && !subTask.endedAt) {

              end = getExpectedEndDate(subTask.startedAt, subTask.executeDays, options.nonWorkingDays, true)
            }

            const startsBeforeWeekStarts = aIsBeforeB(start, options.navigator.startDay)
            const startsSameOrAfterWeekStarts = aIsSameOrAfterB(start, options.navigator.startDay)
            const startsSameOrBeforeWeekEnds = aIsSameOrBeforeB(start, options.navigator.endDay)

            const endsSameOrAfterWeekStarts = aIsSameOrAfterB(end, options.navigator.startDay)
            const endsAfterWeekEnds = aIsAfterB(end, options.navigator.endDay)
            const endsSameOrBeforeWeekEnds = aIsSameOrBeforeB(end, options.navigator.endDay)

            const startsBeforeButEndsInRange = startsBeforeWeekStarts && endsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
            const startsBeforeButEndsAfterRange = startsBeforeWeekStarts && endsAfterWeekEnds
            const startsInRangeAndEndsInRange = startsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
            const startsInRangeButEndsAfter = startsSameOrAfterWeekStarts && startsSameOrBeforeWeekEnds && endsAfterWeekEnds

            return startsBeforeButEndsInRange || startsBeforeButEndsAfterRange || startsInRangeAndEndsInRange || startsInRangeButEndsAfter
          })
        }

        newList.push(item)
      }
    } else {

      const subItems = getLookaheadResult({
        ...options,
        list: item.group.items,
        parentGroupId: position
      })

      if (subItems.length) {

        item.group.position = position

        item.group.items = subItems

        newList.push(item)
      }
    }
  })

  return newList
}

export const getWeeklyResult = (options: any) => {

  const newList: any[] = []

  options.list.forEach((item: any, i: number) => {

    const position = `${options.parentGroupId ? options.parentGroupId + '.' : ''}${i + 1}`

    if (item.type === 'task') {

      const task = options.tasks.find((task: any) => task._id === item.task)

      if (!task)
        return

      if (task.status === 'pendiente') return

      const start = task.startedAt || task.startsAt
      let end

      if (!task.startedAt) {

        end = task.endsAt
      } else if (task.endedAt) {

        end = task.endedAt
      } else if (task.startedAt && !task.endedAt) {

        end = getExpectedEndDate(task.startedAt, task.executeDays, options.nonWorkingDays, true)
      }

      const startsBeforeWeekStarts = aIsBeforeB(start, options.navigator.startDay)
      const startsSameOrAfterWeekStarts = aIsSameOrAfterB(start, options.navigator.startDay)
      const startsSameOrBeforeWeekEnds = aIsSameOrBeforeB(start, options.navigator.endDay)

      const endsSameOrAfterWeekStarts = aIsSameOrAfterB(end, options.navigator.startDay)
      const endsAfterWeekEnds = aIsAfterB(end, options.navigator.endDay)
      const endsSameOrBeforeWeekEnds = aIsSameOrBeforeB(end, options.navigator.endDay)

      const startsBeforeButEndsInRange = startsBeforeWeekStarts && endsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
      const startsBeforeButEndsAfterRange = startsBeforeWeekStarts && endsAfterWeekEnds
      const startsInRangeAndEndsInRange = startsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
      const startsInRangeButEndsAfter = startsSameOrAfterWeekStarts && startsSameOrBeforeWeekEnds && endsAfterWeekEnds

      if (startsBeforeButEndsInRange || startsBeforeButEndsAfterRange || startsInRangeAndEndsInRange || startsInRangeButEndsAfter) {

        task.position = position

        task.startsAt = moment.utc(task.startsAt).format('YYYY-MM-DD HH:mm')
        task.endsAt = moment.utc(task.endsAt).format('YYYY-MM-DD HH:mm')

        if (task.colorCode)
          task.colorCode = options.colorCodes.find((cc: any) => cc._id === task.colorCode)

        task.comments = task.comments.map((comment: any) => {

          comment.user = options.users.find((u: any) => u._id === comment.user)

          return comment
        })

        task.responsibles = task.responsibles.map((resp: string) => {

          if (typeof resp !== 'string') return resp

          return options.users.find((user: any) => user._id === resp)
        })

        task.restrictions = task.restrictions.map((rest: any) => {

          return {
            ...rest,
            createdBy: options.users.find((user: any) => user._id === rest.createdBy)
          }
        })

        task.relations = options.relations.filter((relation: any) => {

          return relation.from_task === task._id || relation.to_task === task._id
        })

        item.task = task

        if (item.subTasks && item.subTasks.length) {

          item.subTasks = item.subTasks.map((subTaskId: string) => {

            const subTask = options.tasks.find((task: any) => task._id === subTaskId)

            if (subTask.colorCode)
              subTask.colorCode = options.colorCodes.find((cc: any) => cc._id === subTask.colorCode)

            return subTask
          }).filter((subTask: any) => {

            const start = subTask.startedAt || subTask.startsAt
            let end

            if (!subTask.startedAt) {

              end = subTask.endsAt
            } else if (subTask.endedAt) {
              end = subTask.endedAt
            } else if (subTask.startedAt && !subTask.endedAt) {

              end = getExpectedEndDate(subTask.startedAt, subTask.executeDays, options.nonWorkingDays, true)
            }

            const startsBeforeWeekStarts = aIsBeforeB(start, options.navigator.startDay)
            const startsSameOrAfterWeekStarts = aIsSameOrAfterB(start, options.navigator.startDay)
            const startsSameOrBeforeWeekEnds = aIsSameOrBeforeB(start, options.navigator.endDay)

            const endsSameOrAfterWeekStarts = aIsSameOrAfterB(end, options.navigator.startDay)
            const endsAfterWeekEnds = aIsAfterB(end, options.navigator.endDay)
            const endsSameOrBeforeWeekEnds = aIsSameOrBeforeB(end, options.navigator.endDay)

            const startsBeforeButEndsInRange = startsBeforeWeekStarts && endsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
            const startsBeforeButEndsAfterRange = startsBeforeWeekStarts && endsAfterWeekEnds
            const startsInRangeAndEndsInRange = startsSameOrAfterWeekStarts && endsSameOrBeforeWeekEnds
            const startsInRangeButEndsAfter = startsSameOrAfterWeekStarts && startsSameOrBeforeWeekEnds && endsAfterWeekEnds

            return startsBeforeButEndsInRange || startsBeforeButEndsAfterRange || startsInRangeAndEndsInRange || startsInRangeButEndsAfter
          })
        }

        newList.push(item)
      }
    } else {

      const subItems = getWeeklyResult({
        ...options,
        list: item.group.items,
        parentGroupId: position
      })

      if (subItems.length) {

        item.group.position = position

        item.group.items = subItems

        newList.push(item)
      }
    }
  })

  return newList
}

export const getRestrictionsResult = (options: any) => {

  const newList: any[] = []

  options.list.forEach((item: any, i: number) => {

    const position = `${options.parentGroupId ? options.parentGroupId + '.' : ''}${i + 1}`

    if (item.type === 'task') {

      const task = options.tasks.find((task: any) => task._id === item.task)

      if (!task.restrictions.length) return

      task.position = position
      task.parent_position = options.parentGroupId
      task.parent_name = options.parentName
      task.parent_id = options.parentId

      task.startsAt = moment.utc(task.startsAt).format('YYYY-MM-DD HH:mm')
      task.endsAt = moment.utc(task.endsAt).format('YYYY-MM-DD HH:mm')

      if (task.colorCode)
        task.colorCode = options.colorCodes.find((cc: any) => cc._id === task.colorCode)

      task.comments = task.comments.map((comment: any) => {

        comment.user = options.users.find((u: any) => u._id === comment.user)

        return comment
      })

      task.restrictions = task.restrictions.map((rest: any) => {

        return {
          ...rest,
          createdBy: options.users.find((user: any) => user._id === rest.createdBy)
        }
      })

      task.relations = options.relations.filter((relation: any) => {

        return relation.from_task === task._id || relation.to_task === task._id
      })

      item.task = task

      if (item.subTasks && item.subTasks.length) {

        item.subTasks = item.subTasks.map((subTaskId: string) => {

          const subTask = options.tasks.find((task: any) => task._id === subTaskId)

          if (subTask.colorCode)
            subTask.colorCode = options.colorCodes.find((cc: any) => cc._id === subTask.colorCode)

          return subTask
        })
      }

      newList.push(item)
    } else {

      const subItems = getRestrictionsResult({
        ...options,
        list: item.group.items,
        parentGroupId: position,
        parentName: item.group.name,
        parentId: item.group._id
      })

      if (subItems.length) {

        item.group.position = position

        item.group.items = subItems

        newList.push(item)
      }
    }
  })

  return newList
}

export const getCollapsedGroups = (project_id: string, page: ProgrammationSchema) => {

  return JSON.parse(localStorage.getItem(`${page}-${project_id}-collapsedItems`) || '[]')
}

export const saveCollapsedGroups = (project_id: string, page: ProgrammationSchema, collapsedGroups: string[]) => {

  localStorage.setItem(`${page}-${project_id}-collapsedItems`, JSON.stringify(collapsedGroups))
}

export const getCollapsedTasks = (project_id: string, page: ProgrammationSchema) => {

  return JSON.parse(localStorage.getItem(`${page}-${project_id}-collapsedTasks`) || '[]')
}

export const saveCollapsedTasks = (project_id: string, page: ProgrammationSchema, collapsedTasks: string[]) => {

  localStorage.setItem(`${page}-${project_id}-collapsedTasks`, JSON.stringify(collapsedTasks))
}

export const getSelectableGroups = (list: any[] = [], exclude_group_id: string, level = 0) => {

  const groups: any[] = []

  list?.map((item: any) => {

    if (item.type === 'group') {

      if (item.group._id === exclude_group_id) return null

      groups.push({
        _id: item.group._id,
        name: `${'-- '.repeat(level)} ${item.group.name}`,
      })

      const subGroups = getSelectableGroups(item.group.items, exclude_group_id, level + 1)

      groups.push(...subGroups)
    }
  })

  return groups
}

export const getNonWorkingDays = (fromString: string, toString: string, project: any) => {

  const workableDays = [
    project.settings.workMonday,
    project.settings.workTuesday,
    project.settings.workWednesday,
    project.settings.workThursday,
    project.settings.workFriday,
    project.settings.workSaturday,
    project.settings.workSunday,
  ]

  const from = fromString.length !== 10 ? moment.utc(fromString) : moment(fromString)
  const to = toString.length !== 10 ? moment.utc(toString) : moment(toString)

  const nonWorkingDays: any = [ ...project.nonWorkingDays.map((day: string) => moment.utc(day).format('YYYY-MM-DD')) ]

  const day = from.clone()

  while (day.isSameOrBefore(to)) {

    const isNonWorkingWeekDay = !workableDays[ day.day() - 1 ]

    const isIncluded = nonWorkingDays.includes(day.format('YYYY-MM-DD'))

    if (isNonWorkingWeekDay && !isIncluded) {

      nonWorkingDays.push(day.format('YYYY-MM-DD'))
    }

    day.add(1, 'day')
  }

  return nonWorkingDays.sort()
}

export const getGroupStartDay = (items: any, collapsedTasks: string[], schema: ProgrammationSchema, nonWorkingDays: string[], stretchUpToday: boolean, moveToScheduledDays: boolean) => {

  let startDay: Moment | undefined

  items.forEach((item: any) => {

    if (item.type === 'task') {

      const taskItem = getTaskitem({ task: item.task, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays, i: 0 })

      const taskStart = moment(taskItem.barStart, 'YYYY-MM-DD')

      if (!startDay || taskStart.isBefore(startDay)) {

        startDay = taskStart.clone()
      }
    } else {

      const groupStartDay = getGroupStartDay(item.group.items, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays)

      if (groupStartDay) {

        if (!startDay || groupStartDay.isBefore(startDay)) {

          startDay = groupStartDay.clone()
        }
      }
    }
  })

  return startDay
}

export const getGroupEndDay = (items: any, collapsedTasks: string[], schema: ProgrammationSchema, nonWorkingDays: string[], stretchUpToday: boolean, moveToScheduledDays: boolean, week?: number) => {

  let endDay: Moment | undefined

  items.forEach((item: any) => {

    if (item.type === 'task') {

      const taskItem = getTaskitem({
        task: item.task,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        i: 0
      })

      let end

      if (taskItem.type === 'hito' || taskItem.type === 'reunion') {

        end = taskItem.startsAt
      } else {

        end = taskItem.barEnd
      }

      const groupEnd = moment(end, 'YYYY-MM-DD')

      if (!endDay || groupEnd.isAfter(endDay)) {

        endDay = groupEnd.clone()
      }
    } else {

      const groupEndDay = getGroupEndDay(item.group.items, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays, week)

      if (groupEndDay) {

        if (!endDay || groupEndDay.isAfter(endDay)) {

          endDay = groupEndDay.clone()
        }
      }
    }
  })

  return endDay
}

export const getExpectedEndDate = (startedAt: string, executeDays: number, nonWorkingDays: string[], stretchUpToday: boolean) => {

  const day = moment(startedAt)

  let days = 0

  while (days < (executeDays - 1)) {

    day.add(1, 'day')

    if (!nonWorkingDays.includes(day.format("YYYY-MM-DD"))) {

      days += 1
    }
  }

  if (stretchUpToday) {

    const today = moment()

    if (day.isBefore(today, 'day')) {

      return today.format('YYYY-MM-DD')
    }
  }

  return day.format('YYYY-MM-DD')
}

interface IPeriodValuesOptions {
  periodStart: string
  periodEnd: string
  nonWorkingDays: string[]
  stretchUpToday: boolean,
  task: any,
  barStart: string,
  barEnd: string,
}

const getItemPeriodValues = (options: IPeriodValuesOptions) => {

  const {
    task,
    periodStart,
    periodEnd,
    barStart,
    barEnd,
    nonWorkingDays,
  } = options

  let barName = task.name
  let progressString = `${task.progress}% / 100%`
  let progress = task.progress

  const taskStartsAfterPeriodStart = moment(barStart).isSameOrAfter(moment(periodStart))

  const taskStartsBeforePeriodStart = moment(barStart).isBefore(moment(periodStart))
  const taskEndsAfterPeriodsEnd = moment(barEnd).isAfter(moment(periodEnd))

  const taskEndsBeforePeriodsEnd = moment(barEnd).isSameOrBefore(moment(periodEnd))

  const week = Number(moment(periodStart).format('YYYYWW'))

  if (taskStartsBeforePeriodStart && taskEndsBeforePeriodsEnd) {

    if (task.progress > 0) {

      if (task.lastWeeklyProgress) {

        if (week - task.lastWeeklyProgress.longWeek === 1) {

          const periodProgressExpected = task.periodProgress - task.lastWeeklyProgress.taskProgress
          const periodProgressDone = task.progress - task.lastWeeklyProgress.taskProgress
          const periodProgressPercent = periodProgressDone * 100 / periodProgressExpected

          progressString = `${periodProgressPercent}% / ${periodProgressExpected}%`
          barName = `${task.name} (${progressString})`
          progress = periodProgressPercent
        } else {

          const percentLeft = 100 - task.lastWeeklyProgress.taskProgress

          const startDay = moment(task.lastWeeklyProgress.longWeek + 1, 'YYYYWW').format('YYYY-MM-DD')

          const daysInPeriod = getItemWidth(periodStart, barEnd, nonWorkingDays, true)
          const daysLeft = getItemWidth(startDay, barEnd, nonWorkingDays, true)

          const periodProgressPercent = daysInPeriod * percentLeft / daysLeft

          progressString = `0% / ${periodProgressPercent.toFixed(0)}%`
          barName = `${task.name} (${progressString})`

          progress = 0
        }
      }
    } else if (task.status === 'atrasada') {

      const executeDays = getItemWidth(barStart, barEnd, nonWorkingDays, true)
      const daysInPeriod = getItemWidth(periodStart, barEnd, nonWorkingDays, true)

      const periodProgressPercent = daysInPeriod * 100 / executeDays

      progressString = `0% / ${periodProgressPercent.toFixed(0)}%`
      barName = `${task.name} (${progressString})`

      progress = 0
    }
  } else if (!taskStartsBeforePeriodStart && taskEndsAfterPeriodsEnd && task.status === 'activa-atrasada') {

    const executeDays = getItemWidth(barStart, barEnd, nonWorkingDays, true)

    const taskWorkableDays = getItemWidth(barStart, periodEnd, nonWorkingDays, true)
    const expectedPercentage = (taskWorkableDays * 100) / executeDays

    const percentageDone = ((task.progress * 100) / expectedPercentage)

    barName += ` (${percentageDone < 100 ? percentageDone.toFixed(0) : 100}% / ${expectedPercentage.toFixed(0)}%)`

    progress = percentageDone
  } else if (!taskStartsBeforePeriodStart && taskEndsAfterPeriodsEnd && task.status !== 'activa-atrasada') {

    const taskWorkableDays = getItemWidth(barStart, periodEnd, nonWorkingDays, true)
    const expectedPercentage = (taskWorkableDays * 100) / task.executeDays

    const percentageDone = ((task.progress * 100) / expectedPercentage)

    barName += ` (${percentageDone < 100 ? percentageDone.toFixed(0) : 100}% / ${expectedPercentage.toFixed(0)}%)`

    progress = percentageDone
  } else if (taskStartsAfterPeriodStart && taskEndsBeforePeriodsEnd) {

    barName += ` (${task.progress}% / 100%)`
  } else if (taskStartsBeforePeriodStart && taskEndsAfterPeriodsEnd) {

    const daysLeft = getItemWidth(periodStart, barEnd, nonWorkingDays, true)
    const daysInPeriod = getItemWidth(periodStart, periodEnd, nonWorkingDays, true)

    if (task.progress > 0) {

      if (task.lastWeeklyProgress) {

        if (week - task.lastWeeklyProgress.longWeek === 1) {

          const progressLeft = 100 - task.lastWeeklyProgress.taskProgress
          const periodProgressExpected = daysInPeriod * progressLeft / daysLeft
          const periodProgressDone = task.progress - task.lastWeeklyProgress.taskProgress
          const periodProgressPercent = periodProgressDone * 100 / periodProgressExpected

          barName = `${task.name} (${periodProgressPercent.toFixed(0)}% / ${periodProgressExpected.toFixed(0)}%)`
          progress = periodProgressPercent
        }
      }
    } else {

      const executeDays = getItemWidth(barStart, barEnd, nonWorkingDays, true)

      const periodProgressPercent = daysInPeriod * 100 / executeDays

      barName = `${task.name} (0% / ${periodProgressPercent.toFixed(0)}%)`

      progress = 0
    }
  }

  return {
    barName,
    progress,
    progressString,
  }
}

interface IGetTaskItemOptions {
  task: any
  position?: string
  collapsedTasks: string[]
  subTasks?: any[]
  schema: ProgrammationSchema
  nonWorkingDays: string[]
  stretchUpToday: boolean,
  moveToScheduledDays: boolean,
  week?: number,
  ganttStart?: string,
  ganttEnd?: string,
  level?: number
  i: number
  j?: number
  k?: number
}

const getTaskitem = (options: IGetTaskItemOptions) => {

  const {
    task,
    position,
    collapsedTasks,
    subTasks,
    schema,
    nonWorkingDays,
    stretchUpToday,
    moveToScheduledDays,
    ganttStart,
    ganttEnd,
    level,
  } = options

  const isCollapsed = collapsedTasks.includes(task._id)

  const { colorCode, comments } = task

  const startsAt = moment(task.startsAt).format("YYYY-MM-DD")
  const startedAt = task.startedAt ? moment(task.startedAt).format("YYYY-MM-DD") : undefined

  const barStart = startedAt || startsAt

  const taskItem: any = {
    _id: task._id,
    schema: 'task',
    level,
    type: task.type,
    name: task.name,
    barName: `${colorCode ? `${colorCode.name} - ` : ''}${task.name} (${task.progress}%/100%)`, // macro
    startsAt,
    executeDays: task.executeDays,
    barStart,
    baseStart: task.baseStart,
    baseEnd: task.baseEnd,
    baseDays: task.baseDays,
    relations: task.relations,
    isCollapsed,
    hasSubTasks: task.hasSubTasks,
    parentId: task.parentId,
    subTasks: task.subTasks,
  }

  if (position) {

    taskItem.position = position
  }

  if (taskItem.type === 'hito' || taskItem.type === 'reunion') {

    return taskItem
  }

  const endsAt = moment(task.endsAt).format("YYYY-MM-DD")
  const endedAt = task.endedAt ? moment(task.endedAt).format("YYYY-MM-DD") : undefined

  let barEnd = endsAt

  if (endedAt) {

    barEnd = endedAt
  } else if (startedAt && !endedAt) {

    barEnd = getExpectedEndDate(startedAt, task.executeDays, nonWorkingDays, stretchUpToday)
  }

  taskItem.colorCodeName = colorCode?.name
  taskItem.colorCodeColor = colorCode?.color
  taskItem.status = task.status
  taskItem.endsAt = endsAt
  taskItem.responsibles = task.responsibles
  taskItem.startedAt = startedAt
  taskItem.endedAt = endedAt
  taskItem.progress = task.progress
  taskItem.confirmed = task.confirmed
  taskItem.barEnd = barEnd
  taskItem.restrictions = task.restrictions?.reduce((acc: any, restriction: any) => {


    if (restriction.checked) {

      acc.done += 1
    }
    acc.toDo += 1

    return acc
  }, { done: 0, toDo: 0, all: task.restrictions })

  if (schema === 'lookahead') {

    taskItem.periodDays = 0
    taskItem.executePercent = 0
    taskItem.unit = task.unit
    taskItem.metered = task.metered
    taskItem.performance = task.performance
    taskItem.crewNumber = task.crewNumber
    taskItem.estimatedDays = task.estimatedDays
  }

  if (schema === 'lookahead' || schema === 'weekly') {

    taskItem.releasesAt = task.releasesAt
    taskItem.comments = comments[ comments.length - 1 ]

    const { barName, progress, progressString } = getItemPeriodValues({
      periodStart: ganttStart || '',
      periodEnd: ganttEnd || '',
      task,
      nonWorkingDays,
      stretchUpToday,
      barStart,
      barEnd,
    })

    taskItem.barName = `${colorCode ? `${colorCode.name} - ` : ''}${barName}`
    taskItem.progressString = progressString
    taskItem.progress = progress
  }

  const bars: any[] = []

  if (subTasks) {

    subTasks.forEach((subTask: any, j: number) => {

      const { colorCode, comments/*, displayMode */ } = subTask

      const startsAt = moment(subTask.startsAt).format("YYYY-MM-DD")
      const startedAt = subTask.startedAt ? moment(subTask.startedAt).format("YYYY-MM-DD") : undefined
      const endsAt = moment(subTask.endsAt).format("YYYY-MM-DD")
      const endedAt = subTask.endedAt ? moment(subTask.endedAt).format("YYYY-MM-DD") : undefined

      const barStart = startedAt || startsAt
      let barEnd = endsAt

      if (endedAt) {

        barEnd = endedAt
      } else if (startedAt && !endedAt) {

        barEnd = getExpectedEndDate(startedAt, subTask.executeDays, nonWorkingDays, stretchUpToday)
      }

      // if (subTask.displayMode === 'scheduled') {

      //   barStart = startsAt
      //   barEnd = endsAt
      // }

      const { barName, progress, progressString } = getItemPeriodValues({
        periodStart: ganttStart || '',
        periodEnd: ganttEnd || '',
        task: subTask,
        nonWorkingDays,
        stretchUpToday,
        barStart,
        barEnd,
      })

      bars.push({
        _id: subTask._id,
        name: subTask.name,
        position: `${taskItem.position}.${j + 1}`,
        progress: progress,
        progressString: progressString,
        barStart: barStart,
        barEnd: barEnd,
        status: subTask.status,
        colorCodeName: colorCode?.name,
        colorCodeColor: colorCode?.color,
        restrictions: subTask.restrictions?.reduce((acc: any, restriction: any) => {

          if (restriction.checked) {

            acc.done += 1
          }
          acc.toDo += 1

          return acc
        }, { done: 0, toDo: 0, all: task.restrictions })
      })
    })
  }

  taskItem.bars = bars

  return taskItem
}

const hasThisUserTasks = (items: any[], user_id: string) => {

  let hasTasks = false

  items.forEach((item: any) => {

    if (item.type === 'task') {

      if (item.task.responsibles.find((responsible: any) => responsible._id === user_id)) {

        hasTasks = true
      }
    } else {

      if (hasThisUserTasks(item.group.items, user_id)) {

        hasTasks = true
      }
    }
  })

  return hasTasks
}

interface ICollapsedGroupBarsOptions {
  groupItems: any[],
  collapsedTasks: string[],
  schema: ProgrammationSchema,
  nonWorkingDays: string[]
  stretchUpToday: boolean
  moveToScheduledDays: boolean
  showOnlyThisUserTasks?: string,
  week?: number,
  ganttStart?: string,
  ganttEnd?: string,
  level?: number,
  i: number
  j?: number
  k?: number
}

const getCollapsedGroupBars = (options: ICollapsedGroupBarsOptions) => {

  const {
    groupItems,
    collapsedTasks,
    schema,
    nonWorkingDays,
    stretchUpToday,
    moveToScheduledDays,
    week,
    ganttStart,
    ganttEnd,
    level,
    j = -1,
    k = -1,
  } = options

  const bars: any[] = []

  groupItems.map((item: any, i: number) => {

    if (item.type === 'task') {

      const { task } = item

      const taskOptions = {
        task,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        ganttStart,
        ganttEnd,
        i,
        j,
      }

      const taskItem = getTaskitem(taskOptions)

      bars.push({
        _id: taskItem._id,
        name: taskItem.name,
        position: taskItem.position,
        progress: taskItem.progress,
        progressString: taskItem.progressString,
        restrictions: taskItem.restrictions,
        responsibles: taskItem.responsibles,
        barStart: taskItem.barStart,
        barEnd: taskItem.barEnd,
        status: taskItem.status,
        colorCodeName: taskItem.colorCodeName,
        colorCodeColor: taskItem.colorCodeColor,
      })
    } else {

      const subBars = getCollapsedGroupBars({
        groupItems: item.group.items,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        ganttStart,
        ganttEnd,
        level,
        i,
        j,
        k,
      })

      bars.push(...subBars)
    }
  })

  return bars
}

interface IGetGroupItemOptions {
  group: any
  collapsedGroups: any[]
  collapsedTasks: string[]
  schema: ProgrammationSchema
  nonWorkingDays: string[]
  stretchUpToday: boolean
  moveToScheduledDays: boolean
  showOnlyThisUserTasks?: string,
  week?: number,
  ganttStart?: string,
  ganttEnd?: string,
  level?: number,
  i: number
  j?: number
  k?: number
}

const getGroupItem = (options: IGetGroupItemOptions) => {

  const {
    group,
    collapsedGroups,
    collapsedTasks,
    schema,
    nonWorkingDays,
    stretchUpToday,
    moveToScheduledDays,
    showOnlyThisUserTasks,
    week,
    ganttStart,
    ganttEnd,
    level,
    j = -1,
    k = -1,
  } = options

  const isCollapsed = collapsedGroups.includes(group._id)

  const bars: any = []

  group.items.forEach((item: any, i: number) => {

    if (item.type === 'task') {

      const { task } = item

      const taskOptions = {
        task,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        ganttStart,
        ganttEnd,
        i,
      }

      const taskItem = getTaskitem(taskOptions)

      bars.push({
        _id: taskItem._id,
        schema: 'task',
        name: taskItem.name,
        position: taskItem.position,
        progressString: taskItem.progressString,
        restrictions: taskItem.restrictions,
        barStart: taskItem.barStart,
        barEnd: taskItem.barEnd,
        status: taskItem.status,
        colorCodeName: taskItem.colorCodeName,
        colorCodeColor: taskItem.colorCodeColor,
      })
    } else {

      const subBars = getCollapsedGroupBars({
        groupItems: item.group.items,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        ganttStart,
        ganttEnd,
        level,
        i,
        j,
        k,
      })

      bars.push(...subBars)
    }
  })

  const barStart = getGroupStartDay(group.items, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays)?.format("YYYY-MM-DD")
  const barEnd = getGroupEndDay(group.items, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays, week)?.format("YYYY-MM-DD")

  const groupItem: any = {
    schema: 'group',
    _id: group._id,
    level,
    position: group.position,
    name: group.name,
    startsAt: barStart,
    endsAt: barEnd,
    barStart,
    barEnd,

    isCollapsed,
    bars,
    hasChildGroup: group.items.some((item: any) => item.type === 'group'),
  }

  if (showOnlyThisUserTasks) {

    groupItem.hasThisUserTasks = hasThisUserTasks(group.items, showOnlyThisUserTasks)
  }

  return groupItem
}

export interface IGetItemsListOptions {
  itemsList: any[],
  collapsedGroups: any[],
  collapsedTasks: string[],
  schema: ProgrammationSchema,
  nonWorkingDays: string[],
  stretchUpToday: boolean,
  moveToScheduledDays: boolean,
  showOnlyThisUserTasks?: string,
  week?: number,
  ganttStart?: string,
  ganttEnd?: string,
  parentId?: string,
  parentPosition?: string,
  level?: number,
}

const getItemPosition = (item: any, schema: ProgrammationSchema, parentGroupId: string, index: number) => {

  // if (schema === 'macro') {

  //   return `${parentGroupId ? parentGroupId + '.' : ''}${index}`
  // }

  if (item.type === 'task') {

    return item.task.position
  }

  return item.group.position
}

export const getGanttItems = (options: IGetItemsListOptions) => {

  const {
    itemsList,
    collapsedGroups,
    collapsedTasks,
    schema,
    nonWorkingDays,
    stretchUpToday,
    moveToScheduledDays,
    showOnlyThisUserTasks,
    week,
    ganttStart,
    ganttEnd,
    parentId,
    parentPosition,
  } = options

  const level = options.level || 0

  const ganttItems: any = []

  itemsList.map((item: any, i: number) => {

    const position = getItemPosition(item, schema, parentPosition || '', i + 1)

    if (item.type === 'task') {

      const { task } = item

      const taskOptions = {
        task,
        position,
        collapsedTasks,
        subTasks: item.subTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        week,
        ganttStart,
        ganttEnd,
        level,
        i,
      }

      const taskItem = getTaskitem(taskOptions)

      // taskItem.position = position
      taskItem.parentId = parentId
      taskItem.parentPosition = parentPosition

      ganttItems.push(taskItem)

      if (task.hasSubTasks && !taskItem.isCollapsed) {

        item.subTasks.forEach((subTask: any, j: number) => {

          const subTaskPosition = `${position}.${j + 1}`

          const subTaskOptions = {
            task: subTask,
            collapsedTasks,
            schema,
            nonWorkingDays,
            stretchUpToday,
            moveToScheduledDays,
            showOnlyThisUserTasks,
            week,
            ganttStart,
            ganttEnd,
            parentId: subTask.parentId,
            level: level + 1,
            i: i + j,
          }

          const subTaskItem = getTaskitem(subTaskOptions)

          subTaskItem.position = subTaskPosition
          subTaskItem.parentPosition = parentPosition

          ganttItems.push(subTaskItem)
        })
      }
    } else {

      const { group } = item

      const groupOptions = {
        group,
        collapsedGroups,
        collapsedTasks,
        schema,
        nonWorkingDays,
        stretchUpToday,
        moveToScheduledDays,
        showOnlyThisUserTasks,
        week,
        ganttStart,
        ganttEnd,
        level,
        i,
      }

      const groupItem = getGroupItem(groupOptions)

      groupItem.position = position
      groupItem.parentId = parentId
      groupItem.parentPosition = parentPosition

      ganttItems.push(groupItem)

      if (collapsedGroups.includes(item.group._id)) return

      const subItems = getGanttItems({
        ...options,
        itemsList: item.group.items,
        parentId: group._id,
        parentPosition: position,
        level: level + 1,
      })

      ganttItems.push(...subItems)
    }
  })

  if (showOnlyThisUserTasks) {

    return ganttItems.filter((item: any) => {
      if (item.schema === 'task' && item._id !== showOnlyThisUserTasks) {
        const hasMatchingResponsible = item.responsibles && item.responsibles.some((responsible: any) => responsible._id === showOnlyThisUserTasks);

        return hasMatchingResponsible;
      }

      if (item.schema === 'group' && !item.hasThisUserTasks) return false;
      return true;
    });
  }

  return ganttItems
}

export const getRestrictionsTableItems = (options: any) => {

  const items: any[] = []

  options.itemsList.forEach((item: any) => {

    if (item.type === 'task') {

      const restrictions: any[] = []

      if (!item.task.hasSubTasks) {

        const restr = [...(item.task.restrictions || [])] // sometimes is undefined

        restr.forEach((restriction: any) => {

          restriction.itemId = item.task._id
          restriction.taskId = item.task.position
          restriction.taskName = item.task.name
          restriction.responsibles = item.task.responsibles
          restriction.taskReleasesAt = item.task.releasesAt || item.task.startsAt
          restriction.createdAt = restriction.createdAt || item.task.createdAt
          restriction.parentPosition = item.task.parent_position
          restriction.parentId = item.task.parent_id
          restriction.parentName = item.task.parent_name

          restrictions.push({
            ...restriction,
          })
        })

      } else {

        item.subTasks.forEach((subTask: any, i: number) => {

          const restr = [...subTask.restrictions]

          restr.forEach((restriction: any) => {

            restriction.itemId = subTask._id
            restriction.taskId = `${item.task.position}.${i + 1}`
            restriction.taskName = item.task.name
            restriction.taskReleasesAt = subTask.releasesAt || subTask.startsAt
            restriction.createdAt = restriction.createdAt || subTask.createdAt

            restriction.responsibles = subTask.responsibles

            restrictions.push({
              ...restriction,
            })
          })

        })
      }

      restrictions.forEach((restriction: any) => {

          const from = moment(restriction.createdAt).format('YYYY-MM-DD')
          const to = (restriction.checked ? moment(restriction.updatedAt) : moment()).format('YYYY-MM-DD')

          const creator = restriction.createdBy ? restriction.createdBy.name + ' ' + restriction.createdBy.surname : ''
          const days = moment(to).diff(from, 'd') + 1

          // const responsibles = item.task.responsibles

          // const createdAt = restriction.createdAt || item.task.createdAt

          items.push({
            ...restriction,
            // itemId,
            // taskId,
            // taskName,
            // taskReleasesAt,
            // parentPosition: item.task.parent_position,
            // parentId: item.task.parent_id,
            // parentName: item.task.parent_name,
            creator,
            days,
            // responsibles,
            // createdAt
          });
      });
    } else {

      const subItems = getRestrictionsTableItems({
        ...options,
        itemsList: item.group.items
      })

      if (subItems.length) {

        items.push(...subItems)
      }
    }
  })

  return items
}

export const getItemParentId = (list: any, item_id: string, parent_id: string = '') => {

  let p_id = ''

  list.forEach((item: any) => {

    if (item.type === 'task') {

      if (item.task._id === item_id)
        p_id = parent_id
    } else {

      if (item.group._id === item_id) {

        p_id = parent_id
      } else {

        const found = getItemParentId(item.group.items, item_id, p_id)

        if (found)
          p_id = found
      }
    }
  })

  return p_id
}

export const getTaskFromTaskList = (list: any[], task_id: string) => {

  let task: any

  list.forEach((item: any) => {

    if (item.type === 'task') {

      if (item.task._id === task_id) {

        task = item.task
      }
    } else {

      const recu = getTaskFromTaskList(item.group.items, task_id)

      if (recu) {

        task = recu
      }
    }
  })

  return task
}

export const getItemAndItsParentFromTaskList = (taskList: any[], itemId: string, group?: any, parentGroupId?: string) => {

  let item: any
  let parent: any

  taskList.map((itemLevel: any, i: number) => {

    const position = `${parentGroupId ? parentGroupId + '.' : ''}${i + 1}`

    if (itemLevel.type === 'task') {

      if (itemLevel.task._id === itemId) {

        item = itemLevel.task
        item.position = position
        item.subTasks = itemLevel.subTasks
        parent = group
      } else {

        const isWork = itemLevel.subTasks?.some((subTask: any) => subTask._id === itemId)

        if (isWork) {

          item = itemLevel.subTasks.find((subTask: any) => subTask._id === itemId)
          item.position = position + '.' + (itemLevel.subTasks.findIndex((subTask: any) => subTask._id === itemId) + 1)
          parent = itemLevel.task
          parent.position = position
        }
      }
    } else {

      if (itemLevel.group._id === itemId) {

        item = itemLevel.group
        item.position = position
        parent = group

        if (parent) {

          parent.position = parentGroupId
        }
      } else {

        const recu = getItemAndItsParentFromTaskList(itemLevel.group.items, itemId, itemLevel.group, position)

        if (recu.item) {
          item = recu.item
          parent = recu.parent
        }
      }
    }
  })

  return { item, parent }
}

export const getTasksResult = ({ list, tasks, users, colorCodes, relations, filters, parentGroupId }: any) => {

  list.forEach((item: any, i: number) => {

    const position = `${parentGroupId ? parentGroupId + '.' : ''}${i + 1}`

    if (item.type === 'task') {

      const task = tasks.find((t: any) => t._id === item.task)

      if (!task) {

        console.log('Task not found', position, item.task)
        return
      }

      task.position = position

      if (task.colorCode)
        task.colorCode = colorCodes.find((cc: any) => cc._id === task.colorCode)

      task.comments = task.comments.map((comment: any) => {

        comment.user = users.find((u: any) => u._id === comment.user)

        return comment
      })

      task.responsibles = task.responsibles.map((resp: string) => {

        return users.find((user: any) => user._id === resp)
      })

      task.restrictions = task.restrictions.map((rest: any) => {

        return {
          ...rest,
          createdBy: users.find((user: any) => user._id === rest.createdBy)
        }
      })

      task.relations = relations.filter((relation: any) => {

        return relation.from_task === task._id || relation.to_task === task._id
      })

      if (task.hasSubTasks) {
        task.subTasks = item.subTasks.map((subTaskId: any) => {

          let subTask = subTaskId

          if (typeof subTaskId === 'string') {

            subTask = tasks.find((task: any) => task._id === subTaskId)
          }

          if (subTask.colorCode)
            subTask.colorCode = colorCodes.find((cc: any) => cc._id === subTask.colorCode)

          return subTask
        })

        item.subTasks = task.subTasks
      }

      item.task = task
    } else {

      item.group.position = position

      item.group.items = getTasksResult({
        list: item.group.items,
        tasks,
        users,
        colorCodes,
        relations,
        filters,
        parentGroupId: position
      })
    }
  })

  return list
}

export const getTasksItems = (items: any[], collapsedTasks: string[], nonWorkingDays: string[], stretchUpToday: boolean, moveToScheduledDays: boolean, user_id?: string) => {

  const tasks: any[] = []

  items?.forEach((item: any, i: number) => {

    if (item.type === 'task') {

      const { task } = item

      const taskItem = getTaskitem({ task, collapsedTasks, schema: 'macro', nonWorkingDays, stretchUpToday, moveToScheduledDays, i })

      if (taskItem.responsibles) {
        const isUserResponsibility = taskItem.responsibles.find((responsible: any) => responsible._id === user_id)

        if (!user_id || (user_id && isUserResponsibility)) {
          tasks.push(taskItem)
        }
      }
    } else {

      const subTasks = getTasksItems(item.group.items, collapsedTasks, nonWorkingDays, stretchUpToday, moveToScheduledDays, user_id)

      tasks.push(...subTasks)
    }
  })

  return tasks
}

export const getGroupFromList = (list: any[], group_id: string, level: number) => {

  let group: any
  let lvl = level

  list.forEach((item: any) => {

    if (item.type === 'group') {

      if (item.group._id === group_id) {

        group = item.group
      } else {

        const res = getGroupFromList(item.group.items, group_id, level + 1)

        if (res.group) {

          group = res.group
          lvl = res.level
        }
      }
    }
  })

  return { group, level: lvl }
}

interface IGetCollapsedGroupItemsOptions {
  group_id: string
  taskList: any[]
  collapsedTasks: string[]
  schema: ProgrammationSchema
  nonWorkingDays: string[]
  stretchUpToday: boolean
  moveToScheduledDays: boolean
  parentPosition?: string
  level?: number
}

export const getCollapsedGroupItems = (options: IGetCollapsedGroupItemsOptions) => {

  const {
    group_id,
    taskList,
    collapsedTasks,
    schema,
    nonWorkingDays,
    moveToScheduledDays,
    stretchUpToday,
    parentPosition,
  } = options

  const lvl = options.level || 0

  const ganttItems: any = []

  const { group, level } = getGroupFromList(taskList, group_id, lvl)

  group?.items.forEach((item: any, i: number) => {

    const position = getItemPosition(item, schema, parentPosition || '', i + 1)

    if (item.type === 'task') {

      const { task } = item

      const taskItem = getTaskitem({ task, collapsedTasks, schema, nonWorkingDays, stretchUpToday, moveToScheduledDays, i })

      taskItem.position = position
      taskItem.parentId = group_id
      taskItem.parentPosition = parentPosition

      ganttItems.push(taskItem)
    } else {

        const { group } = item

        const groupItem = getGroupItem({ group, collapsedTasks, collapsedGroups: [], schema, nonWorkingDays, stretchUpToday, moveToScheduledDays, level, i })

        groupItem.position = position
        groupItem.parentId = group_id
        groupItem.parentPosition = parentPosition

        ganttItems.push(groupItem)

        if (group.items.length > 0) {


          const subItems = getCollapsedGroupItems({
            group_id: groupItem._id,
            taskList,
            collapsedTasks,
            schema,
            nonWorkingDays,
            stretchUpToday,
            moveToScheduledDays,
            parentPosition: position,
            level: level + 1,
          })

          ganttItems.push(...subItems)
        }
    }
  })

  return ganttItems
}

// export const

export const getGroupTasks = (taskList: any[], collapsedTasks: string[]) => {

  const tasks: any[] = []

  taskList.forEach((item: any) => {

    if (item.type === 'task') {

      const { task } = item

      const taskItem = getTaskitem({ task, collapsedTasks, schema: 'macro', nonWorkingDays: [], stretchUpToday: false, moveToScheduledDays: false, i: 0 })

      tasks.push(taskItem)
    } else {

      const subTasks = getGroupTasks(item.group.items, collapsedTasks)

      tasks.push(...subTasks)
    }
  })

  return tasks
}


export const getTasksOptionsFromTaskList = (taskList: any, task: any, level: number, noNameText: string) => {

  const lvl = level || 0

  const getLevelIndentationString = () => {

    let indentation = ''

    for (let i = 0; i < lvl; i++) {

      indentation += '-- '
    }

    return indentation
  }

  const options: any = []

  taskList.map((item: any) => {

    if (item.type === 'task') {

      if (item.task.type === 'partida') {

        options.push({
          value: item.task._id,
          isConfirmed: item.task.confirmed,
          label: `${getLevelIndentationString()} ${task._id === item.task._id ? '➤ ' : ''}${item.task.name}`,
        })
      }
    } else {

      options.push({
        value: item.group._id,
        label: `${getLevelIndentationString()} ${item.group.name}`,
        isGroup: true,
      })

      const subOptions = getTasksOptionsFromTaskList(item.group.items, task, lvl + 1, noNameText)

      options.push(...subOptions)
    }
  })

  return options
}

export const getRestrictionTree = (taskId: string, itemsList: any[]) => {

  const tree: any[] = []

  const item = itemsList.find((item: any) => item.position === taskId)

  if (item) {
    tree.push(`${item.position}. ${item.name}`)

    if (item.parentPosition) {

      const parentTree = getRestrictionTree(item.parentPosition, itemsList)

      if (parentTree) {
        tree.push(...parentTree)
      }
    }
  }

  return tree
}
